export const VIDEO_VALIDATION_FILE_UNSUPPORTED = 'FileTypeUnsupported';
export const VIDEO_VALIDATION_SUSPICIOUS = 'FileSuspiciousContent';
export const VIDEO_VALIDATION_SCAN_ERROR = 'FileScanError';
export const VIDEO_VALIDATION_FPS_TOO_HIGH = 'FPSTooHighError';
export const VIDEO_VALIDATION_RESOLUTION_TOO_HIGH = 'ResolutionTooHighError';
export const VIDEO_VALIDATION_MAX_DURATION = 'MaxDurationError';

// 4gb is the absolute max we allow for now.
// ClamAV, which is what we use to scan the files does
// not support anything larger than 4gb
export const VIDEO_UPLOADS_MAX_FILE_SIZE = 4294967296; // 4gb;

// 4096 is the max width for 4K videos
// 2160 is the max height for 2160p videos
// This combination is a good way to limit videos that are too high resolution
export const MAX_RESOLUTION = 4096 * 2160;
export const MAX_FPS = 60;

export const MAX_HOURS = 12;
export const MAX_DURATION = 60 * 60 * MAX_HOURS;
